/**
 * Zustand state provider implementation.
 *
 * @module
 */
import { createStore } from './store.js';
/**
 * Creates a Zustand state provider for use with `setProvider()` from `@molecule/app-state`.
 * @returns A `StateProvider` that creates Zustand-backed stores.
 */
export const createProvider = () => ({
    createStore: (config) => createStore(config),
});
/** Default Zustand state provider instance. */
export const provider = createProvider();
//# sourceMappingURL=provider.js.map